export default "__VITE_ASSET__Dv21kN8r__"